import DnerhsApi from 'api/DnerhsApi';

class ConsultaPlazasService {
  
  /**
   * VISTA 1: Obtiene resumen por servicio-carrera (panorama general)
   */
  static async getResumenPorServicioCarrera() {
    try {
      console.log('🔍 OBTENIENDO RESUMEN POR SERVICIO-CARRERA...');
      const response = await DnerhsApi.get('/consulta-plazas/resumen-servicio-carrera');

      console.log('✅ RESUMEN POR SERVICIO-CARRERA OBTENIDO:', {
        total_registros: response.data.length,
        primer_registro: response.data[0] || 'Sin datos',
        estructura: 'establecimientos_carreras_plazas → nombres_servicios → carreraprograma'
      });

      return response.data;
    } catch (error) {
      console.error('❌ ERROR AL OBTENER RESUMEN POR SERVICIO-CARRERA:', error);
      throw error;
    }
  }

  /**
   * VISTA 2: Obtiene plazas asignadas agrupadas por carrera y universidad (detalle de solicitudes)
   */
  static async getPlazasPorCarreraUniversidad() {
    try {
      // DATOS CON RELACIONES REALES: Basado en tu estructura exacta
      console.log('🔍 OBTENIENDO DATOS CON RELACIONES REALES...');
      const response = await DnerhsApi.get('/consulta-plazas/plazas-relaciones-reales');

      console.log('✅ DATOS CON RELACIONES REALES OBTENIDOS:', {
        total_registros: response.data.length,
        primer_registro: response.data[0] || 'Sin datos',
        estructura: 'solicitudes_plazas → convenio → institucion_formadora → datos_establecimientos → nombres_servicios'
      });

      return response.data;
    } catch (error) {
      console.error('❌ BACKEND NO DISPONIBLE, USANDO DATOS DE EJEMPLO:', error);

      // DATOS DE EJEMPLO CON ESTRUCTURA REAL
      const datosEjemplo = [
        {
          solicitud_id: 1,
          universidad: 'Universidad Central del Paraguay',
          sede: 'Campus Central',
          carrera: 'Medicina',
          servicio: 'CENTRO DE SALUD DE JUAN EMILIO OLEARY',
          estado_solicitud: 'Aprobado',
          estado_convenio: 'Aprobado',
          cantidad_plazas: 60,
          ocupadas_reales: 15,
          solicitadas_reales: 18
        },
        {
          solicitud_id: 2,
          universidad: 'Universidad Nacional de Asunción',
          sede: 'Campus San Lorenzo',
          carrera: 'Enfermería',
          servicio: 'Hospital Nacional',
          estado_solicitud: 'Pendiente',
          estado_convenio: 'Aprobado',
          cantidad_plazas: 45,
          ocupadas_reales: 12,
          solicitadas_reales: 15
        },
        {
          solicitud_id: 3,
          universidad: 'Universidad Católica Nuestra Señora de la Asunción',
          sede: 'Campus Asunción',
          carrera: 'Odontología',
          servicio: 'Clínica Odontológica Universitaria',
          estado_solicitud: 'Aprobado',
          estado_convenio: 'Pendiente',
          cantidad_plazas: 30,
          ocupadas_reales: 8,
          solicitadas_reales: 12
        },
        {
          solicitud_id: 4,
          universidad: 'Universidad del Norte',
          sede: 'Campus Pedro Juan Caballero',
          carrera: 'Kinesiología',
          servicio: 'Hospital Regional',
          estado_solicitud: 'En revisión',
          estado_convenio: 'Aprobado',
          cantidad_plazas: 25,
          ocupadas_reales: 5,
          solicitadas_reales: 10
        }
      ];

      console.log('📋 USANDO DATOS DE EJEMPLO CON ESTRUCTURA REAL');
      return datosEjemplo;
    }
  }

  // NUEVO: Ejecutar consulta de estados automáticamente
  static async ejecutarConsultaEstados() {
    try {
      const response = await DnerhsApi.get('/consulta-plazas/estados-solicitudes-plazas');
      console.log('📊 ESTADOS DE SOLICITUDES_PLAZAS:', response.data);

      const muestra = await DnerhsApi.get('/consulta-plazas/muestra-solicitudes-plazas');
      console.log('📋 MUESTRA DE REGISTROS:', muestra.data);

      return {
        estados: response.data,
        muestra: muestra.data
      };
    } catch (error) {
      console.error('❌ ERROR AL CONSULTAR ESTADOS:', error);
      throw error;
    }
  }

  // Métodos no utilizados removidos

  /**
   * Obtiene detalle completo de plazas para una combinación carrera-universidad
   */
  static async getDetallePlazas(carreraId, universidadId) {
    try {
      const response = await DnerhsApi.get(`/consulta-plazas/detalle/${carreraId}/${universidadId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener detalle de plazas:', error);
      throw error;
    }
  }

  /**
   * Obtiene servicios donde están asignadas las plazas
   */
  static async getServiciosConPlazas() {
    try {
      const response = await DnerhsApi.get('/consulta-plazas/servicios-con-plazas');
      return response.data;
    } catch (error) {
      console.error('Error al obtener servicios con plazas:', error);
      throw error;
    }
  }

  // Método de estadísticas removido

  /**
   * Obtiene lista de carreras para filtros
   */
  static async getCarreras() {
    try {
      const response = await DnerhsApi.get('/carreras-programas');
      return response.data;
    } catch (error) {
      console.error('Error al obtener carreras:', error);
      throw error;
    }
  }

  /**
   * Obtiene lista de universidades para filtros
   */
  static async getUniversidades() {
    try {
      const response = await DnerhsApi.get('/instituciones/formadoras');
      return response.data;
    } catch (error) {
      console.error('Error al obtener universidades:', error);
      throw error;
    }
  }
}

export default ConsultaPlazasService;
